import _ from "lodash";
import h5plus from "@mainto/h5plus";
// eslint-disable-next-line
import { h5plusReday } from '@mainto/h5plus'
import { BRAND_FAMILY } from "@/constant/brand.js";
import { isInWxMP, isInAliMP, isInTtMP, isInXhsMP } from "@/util/index";

const isInApp = false
let $h5plus = h5plus
h5plusReday().then((res) => {
  isInApp = res.isInApp()
  $h5plus = res
})

const JUMP_MAP = {
  login: {
    h5: "welcome",
    mini: "/pagesB/user/loginByPhone/index",
    app: "/welcome"
  },
  welfareList: {
    h5: "member/milestone",
    mini: "/pagesB/profile/member/milestone/index",
    app: null
  },
  welfareDetail: {
    h5: "member/welfare",
    mini: "/pagesB/profile/member/welfare/index",
    app: null
  }
};

export default {
  computed: {
    jumpPlatform() {
      return this.$route.params.platform;
    },
    isFamily({ jumpPlatform }) {
      return jumpPlatform === BRAND_FAMILY;
    }
  },
  methods: {
    miniRouterLink(type, prodId) {
      this.$sensors.track("onPage_bannerClick", {
        banner_area_type: "产品承接页",
        banner_area_name: "产品承接页",
        product_id: prodId,
        banner_title: "",
        brand: type
      });
      let weixin = isInWxMP();
      // 判断是否是小程序webview访问
      if (weixin || weixin.length || window.my || window.tt) {
        // eslint-disable-next-line
        let url;

        if (this.isFamily) {
          url = `/pagesA/productDetail/index?id=${prodId}`;
        } else {
          url = `/pagesA/product/prodDetail/index?brand=${type}&showPid=${prodId}&pickPid=${prodId}`;
        }
        if (window.my) {
          window.my.navigateTo({ url });
        } else if (window.wx) {
          // window.wx.miniProgram.navigateTo({ url })
          let Fn = window.wx.miniProgram;
          // 测试发现，miniProgram时有时没有？ 到底是window.wx 还是window.wx.miniProgram

          if (_.isEmpty(Fn)) {
            return window.wx.navigateTo({ url });
          }

          return window.wx.miniProgram.navigateTo({ url });
        } else if (window.tt) {
          return window.tt.miniProgram.navigateTo({ url });
        } else if (xhs) {
          return xhs.miniProgram.navigateTo({ url });
        }
      } else {
        if (isInApp) {
          // PRODUCT_DETAIL
          $h5plus.navigate({ path: `/prodDetail/${type}/${prodId}/${prodId}` })
        } else {
          window.location.href =
            process.env.VUE_APP_ENV_NEW_WEB_HOST + `prodDetail/${type}/${prodId}/${prodId}`;
        }
      }
    },
    generalJumpFn(type, queryMap) {
      const route = JUMP_MAP[type];
      let { mini, app, h5 } = route;

      const queryList = _.transform(
        queryMap,
        (sum, item, key) => {
          sum.push(`${key}=${item}`);
        },
        []
      ).join("&");

      if (queryList.length > 0) {
        mini = `${mini}?${queryList}`;

        h5 = `${h5}?${queryList}`;
      }

      switch (true) {
      case isInWxMP():
        this.wxJump(mini);
        break;

      case isInAliMP():
        this.aliJump(mini);
        break;

      case isInTtMP():
        this.ttJump(mini);
        break;

      case isInXhsMP():
        this.xhsJump(mini);
        break;

      case isInApp:
        this.appJump(app);
        break;

      default:
        this.h5Jump(process.env.VUE_APP_ENV_NEW_WEB_HOST + h5);
        break;
      }
    },
    aliJump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      if (this.isFamily) throw new Error("Jump family is not supported");
      return window.my.navigateTo({ url });
    },
    wxJump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      let Fn = window.wx.miniProgram;
      // 测试发现，miniProgram时有时没有？ 到底是window.wx 还是window.wx.miniProgram
      if (_.isEmpty(Fn)) return window.wx.navigateTo({ url });
      return Fn.navigateTo({ url });
    },
    ttJump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      if (this.isFamily) throw new Error("Jump family is not supported");
      return window.tt.miniProgram.navigateTo({ url });
    },
    xhsJump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      if (this.isFamily) throw new Error("Jump family is not supported");
      return xhs.miniProgram.navigateTo({ url });
    },
    appJump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      if (this.isFamily) throw new Error("Jump family is not supported");
      if (url.startsWith('http')) {
        window.$location.href = url
      } else {
        $h5plus.navigate({ path: url })
      }
    },
    h5Jump(url) {
      if (_.isEmpty(url)) throw new Error("url is empty");
      if (this.isFamily) throw new Error("Jump family is not supported");
      window.location.href = url;
    }
  }
};
